import React from "react";
import {LayoutAuthWithForm} from "../../../layouts";
import {AuthCheckbox, AuthInput, AuthPwdInput} from "../../../helpers/InputsHelpers";
import {Box} from "@material-ui/core";
import trim from "mn-utils/trim";
import {bool, object, string} from "yup";
import {account$} from "../../../../emitters/account";
import toLower from "mn-utils/toLower";
import {Link, pushLocation} from "../../../../router";
import {
  LINK_SIGN_IN,
  LINK_START_VERIFICATION
} from "../../../../constants/links";
import delay from "mn-utils/delay";
import {resendVerificationCode} from "../VerificationCode/utils/resendVerification";

export default () => {
  const schema = object({
    email: string().isValidEmail().required(),
    password: string()
      .isValidNewPwd()
      .isValidPwdLength()
      .withoutCyrillicSymbols()
      .required(),
    termsCheck: bool().oneOf([true], "Please accept").required(),
  });

  const onSubmit = (data) => (
    account$.signUpMerchant({
      email: data.email,
      password: data.password,
      disclaimer_accepted: true,
    }).then((response) => {
      pushLocation({
        path: LINK_START_VERIFICATION + '/' + encodeURIComponent(data.email) + '/',
      });
      delay(resendVerificationCode, 100, [response.confirm_timeout]);
    })
  );

  return (
    <LayoutAuthWithForm
      title="Create your account"
      description="Join our Retailer community"
      formProps={{
        schema,
        onSubmit
      }}
      content={(formCtx) => (
        <>
          <AuthInput
            name="email"
            formCtx={formCtx}
            onChangeHandlers={[
              trim,
              toLower
            ]}
          />
          <Box mt="3rem">
            <AuthPwdInput
              name="password"
              formCtx={formCtx}
              onChangeHandlers={[trim]}
            />
          </Box>
        </>
      )}
      preFooterFormElement={(formCtx) => (
        <AuthCheckbox
          name="termsCheck"
          formCtx={formCtx}
          label={(
            <>
              by checking this button, I accept <a
                className="c5B47FF dn o70:h"
                href="https://lunu.io/terms"
                target="_blank"
                rel="noreferrer"
                onClick={(e) => e.stopPropagation()}
              >
                all Lunu Terms and conditions
              </a> and <a
                className="c5B47FF dn o70:h"
                href="https://lunu.io/privacy"
                target="_blank"
                rel="noreferrer"
                onClick={(e) => e.stopPropagation()}
              >
                Privacy policy
              </a>
            </>
          )}
        />
      )}
      submitBtnText="Sign Up"
      additional={(
        <>
          <span className="pr12 f12 fw3 lh lts0em">
            Already have an account?
          </span>
          <span className="rlv st-2 wmin72">
            <Link
              xhref={LINK_SIGN_IN}
              href={LINK_SIGN_IN}
              className="c5B47FF olN tdU dn f16 fw3 o70:h"
            >Sign in</Link>
          </span>
        </>
      )}
    />
  )
}
